<template>
    <div>
        <Dialog v-if="addSlot_dialog" :commonDialog="addSlot_dialog" :dialogWidth="768">
            <template v-slot:title>Create Slots
                {{ duration_type }}
            </template>
            <template v-slot:body>
                <v-container>

                    <v-row>
                        <v-col lg="6">
                            <label> Slot Duration </label>
                            <div style="display: flex; overflow: hidden">
                                <v-select :items="durationTypes" item-value="day_of_week" item-text="day_of_week"
                                    v-model="duration_type" placeholder="Duration Type" dense filled flat solo
                                    class="ma-0" style="border-radius: 0; flex: 1"></v-select>
                                <v-text-field week_id="slot_duration" v-model="slot_duration" type="number" dense filled
                                    :rules="slotRules" flat solo color="cyan" placeholder="Slot Duration" class="ma-0"
                                    style=" 
                    flex: 1;
                  "></v-text-field>


                            </div>
                        </v-col>
                        <v-col lg="6">
                            <label> Gap Between Slots </label>
                            <v-text-field v-model="gap_between_slots" dense filled placeholder="Gap Between Slots"
                                suffix="minutes" solo flat color="cyan" type="number" :rules="[validateRules.greaterThenZero(gap_between_slots, 'Slots'), v => !!v || 'Slot duration is required',
                                v => v > 0 || 'Must be greater than 0',
                                v => v % 15 === 0 || 'Only multiples of 15 allowed (15, 30, 45...)']"></v-text-field>
                            <span class="text-error" style="color:red"
                                v-if="gap_between_slots && gap_between_slots <= 0">
                                Value should be greater than 0.
                            </span>


                        </v-col>
                    </v-row>
                    <div style="color: red;">
                        When minutes are selected, enter a slot duration in multiples of 15.
                    </div>
                    <v-row>
                        <v-col lg="6">
                            <label> Start Time </label>
                            <TimePicker v-model="start_time" :intervel="15" />
                        </v-col>
                        <v-col lg="6">
                            <label> End Time </label>
                            <TimePicker v-model="end_time" placeholder="End Time" :intervel="15" :disabled="!start_time"
                                :min-time="start_time" />
                        </v-col>
                    </v-row>
                </v-container>

                <table width="100%" v-if="viewSlotData?.length > 0">
                    <thead>
                        <th>S.no</th>
                        <th>Slots</th>
                        <th>Slot Duration</th>
                        <th>Status</th>
                    </thead>
                    <template v-if="viewSlotData.length > 0">
                        <tr v-for="(row, index) in viewSlotData" :key="index">
                            <td class="font-size-14 font-weight-500" align="center" valign="middle">
                                {{ index + 1 }}
                            </td>
                            <td>{{ row.start }}-{{ row.end }}</td>

                            <td>
                                <v-text-field readonly solo flat dense filled hide-details
                                    :value="row.duration"></v-text-field>
                            </td>
                            <td>
                                <v-switch v-model.trim="row.is_active" inset :true-value="1" :false-value="0"
                                    color="green" hide-details class="mt-0"></v-switch>
                            </td>
                            <td>
                                <v-tooltip top content-class="custom-top-tooltip">
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-icon @click="deleteSchedule(index)" color="deep-orange" v-bind="attrs"
                                            v-on="on">
                                            mdi-delete
                                        </v-icon>
                                    </template>
                                    <span>Click here to delete </span>
                                </v-tooltip>
                            </td>
                        </tr>
                    </template>
                    <tr v-else>
                        <td colspan="6" class="py-4">
                            <p class="m-0 row-not-found text-center font-weight-500 font-size-16">
                                <img :src="$assetURL('media/error/empty.png')" class="row-not-found-image" />
                                Uhh... There are no slot at this moment.
                            </p>
                        </td>
                    </tr>
                </table>
            </template>
            <template v-slot:action>

                <v-btn class="mx-2 custom-grey-border custom-bold-button"
                    v-on:click="addSlot_dialog = !addSlot_dialog, emptyAllWeekSlot(), $emit('close-dialog', true)">
                    Close
                </v-btn>
                <div class="d-flex mx-2 custom-bold-button white--text" color="cyan">
                    <v-btn @click="updateSlots()" v-if="viewSlotData.length > 0"
                        class="mt-0  custom-grey-border custom-bold-button white--text" color="cyan">
                        Update Slots
                    </v-btn>
                    <v-btn v-else @click="getSlots()" :disabled="!isFormValid"
                        class="mt-0  custom-grey-border custom-bold-button white--text" color="cyan">
                        Get Slots
                    </v-btn>

                </div>
            </template>

        </Dialog>


    </div>
</template>
<script>
import TimePicker from "@/view/components/TimePicker.vue";
import Dialog from "@/view/pages/partials/Dialog.vue";
import moment from "moment-timezone";
moment.tz.setDefault(process.env.VUE_APP_TIMEZONE);
import { ErrorEventBus } from "@/core/lib/message.lib";
import { InitializeError } from "@/core/lib/message.lib";
import ValidationMixin from "@/core/plugins/validation-mixin";

export default {
    mixins: [ValidationMixin],
    data() {
        return {
            start_time: "",
            end_time: "",
            gap_between_slots: "",
            slot_duration: "",
            duration_type: "",
            viewSlotData: [],

        }
    },
    mounted() {

    },
    watch: {
        slot_duration_type: {
            handler() {
                this.duration_type = this.slot_duration_type
            }
        },
        editSlotData: {
            handler() {
                this.duration_type = this.editSlotData.duration_type ?? null
                this.end_time = this.editSlotData.end_time ?? null
                this.gap_between_slots = this.editSlotData.gap_between_slots ?? null
                this.start_time = this.editSlotData.start_time ?? null
                this.slot_duration = this.editSlotData.slot_duration ?? null
                console.log(45646, this.start_time);

            }
        },

        slotDuration: {
            handler() {
                this.slot_duration = this.slotDuration;
            }
        }
    },
    methods: {
        emptyAllWeekSlot() {
            this.viewSlotData = [];
            this.start_time = "";
            this.end_time = "";
            this.gap_between_slots = "";
            this.slot_duration = "";
            this.duration_type = "";
        },

        updateSlots() {
            this.$emit('saveUpdatedSlots',
                this.viewSlotData,
                this.slot_duration,
                this.duration_type,
                this.start_time,
                this.end_time,
                this.gap_between_slots,
            );
            this.emptyAllWeekSlot();
        },
        deleteSchedule(index) {
            this.viewSlotData.splice(index, 1);
        },
        getSlots() {
            const start_time = this.start_time;
            const gap_between_slots = Number(this.gap_between_slots);
            const end_time = this.end_time;

            let slot_duration = Number(this.slot_duration);
            const startMinutes = this.timeToMinutes(start_time);
            const endMinutes = this.timeToMinutes(end_time);
            if (this.duration_type === "Hours" && slot_duration >= 24)
                return ErrorEventBus.$emit("update:error", InitializeError("Hour cannot be equal to or greater than 24."));

            if (this.duration_type === "Hours") slot_duration *= 60;

            let currentTime = startMinutes;
            const slots = [];
            while (currentTime + slot_duration <= endMinutes) {
                const slotStart = this.minutesToTime(currentTime);
                const slotEnd = this.minutesToTime(currentTime + slot_duration);
                slots.push({
                    start: `${slotStart}`,
                    end: `${slotEnd}`,
                    duration: `${slot_duration} mins`,
                    is_active: 1,
                });
                currentTime += gap_between_slots;

            }
            if (slots?.length < 1) {
                return ErrorEventBus.$emit("update:error", InitializeError("No Slot found between this time frame."));
            }
            this.viewSlotData = slots;

        },
        timeToMinutes(timeStr) {
            const cleanTimeStr = timeStr.trim();
            const timeRegex = /^(\d{1,2}):(\d{2})\s*(AM|PM)$/i;
            const match = cleanTimeStr.match(timeRegex);

            if (!match) {
                const [hours, minutes] = cleanTimeStr.split(":").map(Number);
                return hours * 60 + minutes;
            }

            let hours = parseInt(match[1]);
            const minutes = parseInt(match[2]);
            const period = match[3].toUpperCase();
            if (period === "AM" && hours === 12) {
                hours = 0;
            } else if (period === "PM" && hours !== 12) {
                hours += 12;
            }

            return hours * 60 + minutes;
        },
        minutesToTime(minutes) {
            const hours24 = Math.floor(minutes / 60);
            const mins = minutes % 60;
            const period = hours24 >= 12 ? "PM" : "AM";
            const hours12 =
                hours24 === 0 ? 12 : hours24 > 12 ? hours24 - 12 : hours24;

            return `${hours12.toString().padStart(2, "0")}:${mins
                .toString()
                .padStart(2, "0")} ${period}`;
        },
    },
    props: {
        addSlot_dialog: {
            type: Boolean,
            default: false
        },
        editSlotData: {
            type: [Array, Object],
            default: () => ({})
        },
        slotDuration: {
            type: [String, Array, Number],
            default: 0
        },
        slot_duration_type: {
            type: String,
            default: ""
        },

        durationTypes: {
            type: Array,
            default: () => [{ day_of_week: "Minutes", value: "minutes" },
            { day_of_week: "Hours", value: "hours" }]
        },
    },
    components: {
        TimePicker,
        Dialog
    },
    computed: {
        isFormValid() {
            return (
                this.slot_duration > 0 &&
                this.duration_type &&
                this.gap_between_slots > 0 &&
                this.start_time &&
                this.end_time &&
                (
                    this.duration_type !== 'Minutes' ||
                    (this.slot_duration % 15 === 0 && this.gap_between_slots % 15 === 0)
                )
            );
        },
        slotRules() {
            if (this.duration_type == "Minutes") {
                return [
                    v => !!v || 'Required',
                    v => v % 15 === 0 || 'Only multiples of 15 allowed'
                ];
            }

            // No rule (or minimal rule)
            return [
                v => !!v || 'Required'
            ];
        }
    }
}
</script>
<style scoped>
.removeShadow>.v-input__control>.v-input__slot {
    box-shadow: none !important;
}

.v-autocomplete:not(.v-input--is-focused).v-select--chips input {
    padding: 0;
}

.v-application .py-3 {
    padding-bottom: 0px !important;
}

.text-right.col-md-12.col {
    margin: -10px;
}

.styled-table {
    border-collapse: collapse;
    width: 100%;
    font-size: 14px;
}

.styled-table th,
.styled-table td {
    border: 1px solid #ddd;
    padding: 8px;
}

.styled-table th {
    background-color: #f4f4f4;
    font-weight: bold;
    text-align: left;
}

.styled-table tr:nth-child(even) {
    background-color: #f9f9f9;
}

.styled-table tr:hover {
    background-color: #f1f1f1;
}
</style>
